import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppToastManagerService } from '../../../shared/services/toast-manager.service';
import { Observable, Subject, takeUntil } from "rxjs";
import { CustomRostersResponseDto } from '@whetstoneeducation/hero-common';
import { AppCustomRostersService } from '../custom-rosters.service';

@Component({
  selector: 'app-import-students-modal',
  templateUrl: './import-students-modal.component.html',
  styleUrls: ['./import-students-modal.component.scss']
})
export class ImportStudentsModalComponent
  implements OnDestroy, OnInit
{
  public allowedFileExtensions = ['.csv'];
  public customRoster: CustomRostersResponseDto;
  
  protected file?: File = null;
  
  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    public dialogRef: MatDialogRef<ImportStudentsModalComponent>,
    private readonly toastService: AppToastManagerService,
    private customRosterService: AppCustomRostersService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      customRoster: CustomRostersResponseDto;
    }
  ) { }

  ngOnInit(){
    this.customRoster = this.data.customRoster;
  }

   async ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public handleFileChanged(file?: File): void {
    this.file = file;
  }

  uploadFile() {
    const reader = new FileReader();

    reader.onload = async (e) => {
      const uploadResult: Observable<Object> = await this.customRosterService.importCsvCustomRoster(this.file, this.customRoster.id);

      if (uploadResult) {
        uploadResult.pipe(takeUntil(this.destroy$)).subscribe((result) => {

        if (result['status'] === 'success') {
          this.toastService.success('Student import started. Refresh later to see changes.');
          this.dialogRef.close();
        } else {
          this.toastService.error('Error importing student(s)');
        }
        });
      } else {
        this.toastService.error('Error importing student(s)');
      }
    };

    reader.readAsDataURL(this.file);
  }


  protected readonly close = close;
}